module.exports = __webpack_public_path__ + "static/media/tornadoManega.742c2adf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/avis/tornadoManega.svg
// module id = 827
// module chunks = 0